import './style.scss';

import { ChatBtnType, TransactionItemType, TransactionListItemType, TransactionType } from '@/types/Transaction';
import { TRACKING_TYPE, Transaction as TransactionTS } from '@/utils/constants';
import { inject, observer } from 'mobx-react';

import API from '@/services';
import { InitStoreType } from '@/types/store/init';
import React from 'react';
import { TrackerProps } from '@/types/common';
import Transaction from '../Transaction';
import { getTrans } from '@/utils/tools';
import { mapDataToTransaction } from '../Transaction/utils';
import { tracker } from '@/utils/tracking';
import { getChildInject } from '@/utils/instantLoaded/tools';

type State = {
  dataSource: TransactionListItemType[];
  footerButtonId: string;
  footerButtonType: string;
};

interface InjectedProps {
  initStore?: InitStoreType; // 👍 no question mark here, and no interface inheritance
}

export type MoreTransactionListProps = {
  dialogueId: string;
  type: TransactionType;
  buttons_for_live: ChatBtnType & { message: string };
  onFooterClick?: (buttons_for_live: ChatBtnType & { message: string }, trackingdata: any) => void;
  onClick?: (transaction: TransactionItemType, index: number) => void;
  initStore?: InitStoreType;
  nodePointId?: string;
  button_no_have?: ChatBtnType & { message: string };
} & TrackerProps;

@inject(getChildInject('initStore'))
@observer
class TransactionList extends React.PureComponent<MoreTransactionListProps, State> {
  get injected(): InjectedProps {
    return this.props as MoreTransactionListProps & InjectedProps;
  }

  state: Readonly<State> = {
    dataSource: [],
    footerButtonId: '',
    footerButtonType: '',
  };

  constructor(props: any) {
    super(props);
  }

  getData = async () => {
    const { type } = this.props;
    const data = await (API as { transactionsLoadMore: Function })
      .transactionsLoadMore({ transaction_type: type })
      .catch((err: Error) => { });

    if (!data) {
      return;
    }

    this.setState({
      dataSource: data?.transactions_list,
      footerButtonId: data?.button_id,
      footerButtonType: data?.button_type,
    });
  };

  componentDidMount() {
    this.getData();
  }

  renderTransactionItem = (transaction: any, index: number) => {
    const { type, initStore: { sessionId = '' } = {}, dialogueId, tracker, passedRef, onClick, nodePointId } = this.props;
    const trackingdata = {
      chat_session_id: sessionId || '',
      chat_dialogue_id: dialogueId,
      card_type: type === TransactionType.Topup ? 'topup' : 'withdraw',
      node_point_id: nodePointId,
      button_type: transaction.button_type,
      button_id: transaction.button_id,
    };

    const props = mapDataToTransaction(type, transaction);

    return (
      <React.Fragment key={transaction.sn}>
        {index !== 0 && <div className="gap"></div>}
        <Transaction
          ref={(ele) => {
            if (ele) {
              ele.dataset.trackingname = TRACKING_TYPE.SHOPEE_PAY_PANEL_TRANSACTION_CARD;
              ele.dataset.trackingindex = index.toString();
              ele.dataset.trackingdata = JSON.stringify({
                ...trackingdata,
                location: index,
              });

              passedRef(ele, index + 1);

              tracker.impression.addObserver(index + 1);
            }
          }}
          layout="vertical"
          {...props}
          onClick={() => {
            onClick && onClick(transaction, index);
          }}
        />
      </React.Fragment>
    );
  };

  renderFooter = () => {
    const { footerButtonType, footerButtonId } = this.state;
    const { initStore: { sessionId = '' } = {}, dialogueId, type, onFooterClick, buttons_for_live, passedRef, tracker, nodePointId } = this.props;

    const trackingname = TRACKING_TYPE.SHOPEE_PAY_PANEL_DONT_SEE_BUTTON;
    const trackingdata = {
      chat_session_id: sessionId || '',
      chat_dialogue_id: dialogueId,
      card_type: type === TransactionType.Topup ? 'topup' : 'withdraw',
      node_point_id: nodePointId,
      button_text: buttons_for_live.message,
      button_type: footerButtonType,
      button_id: footerButtonId,
    };

    return (
      <div
        data-trackingname={trackingname}
        data-trackingdata={JSON.stringify(trackingdata)}
        ref={(ele) => {
          if (ele && footerButtonId && footerButtonType) {
            // 将footer按钮初始化在第一位
            passedRef(ele, 0);
            tracker.impression.addObserver(0);
          }
        }}
        className="transaction-list-footer"
        onClick={() => {
          onFooterClick && onFooterClick(buttons_for_live, {
            button_id: footerButtonId,
            button_type: footerButtonType,
            button_text: buttons_for_live.message,
          });
        }}
      >
        <div className="text">{buttons_for_live.message}</div>
      </div>
    );
  };

  render() {
    const { type } = this.props;
    const { dataSource } = this.state;

    return (
      <div className="transaction-list-container-vertical">
        <div className="title">{type === TransactionType.Withdrawal ? getTrans(TransactionTS.labelWithdrawal, 'Withdrawal') : getTrans(TransactionTS.labelTopup, 'Topup')}</div>
        <div className="scroll-list-container">
          {dataSource.map((transaction, index) => this.renderTransactionItem(transaction, index))}
        </div>
        {this.renderFooter()}
      </div>
    );
  }
}

export default tracker(TransactionList);
